import type { SVGProps } from 'react'
const IconClipboardTextBoldIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.02 16.159H8.99c-.42 0-.75-.33-.75-.75 0-.41.33-.75.75-.75h6.03c.42 0 .75.34.75.75 0 .42-.33.75-.75.75m-6.03-5.51H12c.42 0 .75.34.75.76 0 .41-.33.74-.75.74H8.99a.74.74 0 0 1-.75-.74c0-.42.33-.76.75-.76m7.903-6.268c-.12-.036-.238.054-.256.178a2.48 2.48 0 0 1-2.447 2.12H9.81a2.49 2.49 0 0 1-2.457-2.12c-.018-.124-.136-.214-.256-.178A4.25 4.25 0 0 0 4.07 8.459v8.9c0 2.34 1.9 4.25 4.25 4.25h7.36c2.35 0 4.25-1.91 4.25-4.25v-8.9a4.25 4.25 0 0 0-3.037-4.078"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.814 5.48h4.38c.68 0 1.24-.54 1.26-1.22.01-.02.01-.04.01-.06v-.54c0-.7-.57-1.27-1.27-1.27h-4.38c-.7 0-1.28.57-1.28 1.27v.54c0 .02 0 .03.01.05.02.69.59 1.23 1.27 1.23"
      clipRule="evenodd"
    />
  </svg>
)
export default IconClipboardTextBoldIcon
